import Related from './Related';
import Template from './Template';
import { Form } from 'antd';
import { useState } from 'react';

export default function Subject({ getEmailSettings, emailList, loading }) {
    const [form] = Form.useForm();
    const [isEditable, setIsEditable] = useState(false);

    return (
        <div className="grid grid-cols-7 gap-4">
            <div className="bg-white col-span-2 rounded-lg h-max">
                <Related
                    isEditable={isEditable}
                    form={form}
                    emailList={emailList}
                    loading={loading}
                />
            </div>
            <div className="bg-white col-span-5 rounded-lg p-4">
                <Template
                    isEditable={isEditable}
                    setIsEditable={setIsEditable}
                    form={form}
                    getEmailSettings={getEmailSettings}
                />
            </div>
        </div>
    );
}
